<template>
  <div id="dashboard" class="">
    <section class="bannerprincipal pb-2">
      <SiteNav></SiteNav>
      <div
        class="col-12 text-center py-3"
        data-aos="fade-down"
        data-aos-delay="100"
      >
        <div class="row">
          <div class="col-6">
            <router-link to="/">
              <img
                class="pt-5 img-fluid"
                src="../assets/imgs/capistrano2021/logo-capistrano-interior.png"
                alt="Capistrano"
              />
            </router-link>
          </div>
          <div class="col-6 d-flex align-items-center">
            <router-link to="/">
              <img
                class="pt-5 img-fluid"
                src="../assets/imgs/capistrano2021/el-sabor-que-te-premia.png"
                alt="Capistrano"
              />
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="pt-5 resultados">
      <div class="container ">
        <div class="row pt-5">
          <div class="col-12 text-center pb-5">
            <img
                class="pt-5 img-fluid"
                src="../assets/imgs/capistrano2021/resultados.png"
                alt="Capistrano"
              />
          </div>
          <div class="col-12 pb-1 pt-4" v-if="user != null">
            <!-- <p class="fG text-right pb-3 bold">
              <strong
                >Tu objetivo en Kg por semana:
                <span class="rojo">{{ user.objetivo_semanal }} kg</span>
              </strong>
            </p> -->
            <p class="fG text-right pb-3 bold">
              <strong
                >No. de cliente:
                <span class="rojo">{{ user.no_cliente }}</span>
              </strong>
            </p>
            <p class="fG text-right pb-3 bold">
              <strong>
                <span class="rojo">{{ user.clasificacion }}</span>
              </strong>
            </p>
            <p class="fXG text-left">
              Bienvenido(a)
              <span class="rojo bold">{{ user.nombre }}</span>
            </p>

            <p class="fG2 text-left" v-if="semana > 0">
              Tus resultados de la <strong>Semana {{ semana }}</strong> son:
            </p>
            <p class="fG2 text-left"  v-else>
              Aún no se publican resultados.
            </p>
          </div>

          <!-- <div class="col-12 pb-5 text-center fG2">
            Aún no hay resultados para esta semana.
          </div> -->

          <div class="col-12 pb-5" v-if="resultados_usuario != null && semana > 0">
            <table class="tablacapis tablacapis2">
              <thead>
                <th>Objetivo Semanal (Kg)</th>
                <th>Venta (Kg)</th>
                <th>Alcance</th>
                <!-- <th>Facturación</th> -->
              </thead>
              <tbody>
                <tr>
                  <td>{{ resultados_usuario.objetivo_semanal }} kg</td>
                  <td>{{ resultados_usuario.kg }} kg</td>
                  <td>{{ resultados_usuario.incremento }}%</td>
                  <!-- <td>${{formatPrice(resultados_usuario.facturacion)}}</td> -->
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-12 pb-2" v-if="user != null && semana > 0">
            <div class="fG2 bold">Top del {{ user.clasificacion }}</div>
          </div>

          <div class="col-12 pb-5" v-if="semana > 0">
            <table class="tablacapis">
              <thead>
                <th>Sucursal</th>
                <th>Alcance</th>
              </thead>
              <tbody>
                <tr
                  v-for="cliente of resultados_top_grupo"
                  :key="cliente.no_cliente"
                >
                  <td>{{ cliente.nombre_completo }}</td>
                  <td>{{ cliente.incremento }}%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>

    <section class="py-5 ganadores">
      <div class="container" data-aos="fade-up" data-aos-delay="200">
        <div class="row">
          <div class="col-12 text-center titlerojo fXG bold pb-5">
            Ganadores
          </div>
          <div class="col-12 text-center fG py-2">
            Consulta la lista de ganadores aquí:
          </div>
          <div class="col-12 text-center pb-5">
            <router-link
              to="/ganadores"
              class="
                amarillo
                pointer
                d-flex
                align-items-center
                justify-content-center
                btnaction
                fG
                ml-auto
                mr-auto
                w-100
              "
            >
              VER RESULTADOS
            </router-link>
          </div>
        </div>
      </div>
    </section> 

    <Footer></Footer>
  </div>
</template>

<script>
import { commentsCollection } from "@/firebase";
import { mapState } from "vuex";
import moment from "moment";
import AOS from "aos";
import swal from "sweetalert2";

import SiteNav from "@/components/SiteNav";

import Footer from "@/components/Footer";

var formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export default {
  components: {
    Footer,
    SiteNav,
  },
  data() {
    return {
      post: {
        content: "",
      },
      showCommentModal: false,
      selectedPost: {},
      showPostModal: false,
      fullPost: {},
      postComments: [],
      file: null,
      monedero: "",
      no_transaccion: null,
      no_sucursal: null,
      disponibles: [
        "merida",
        "fantasma",
        "forrest",
        "gladiador",
        "id4",
        "lalaland",
        "malefica",
        "parque-jurasico",
        "psicosis",
        "pulp",
        "et",
        "chucky",
        "diario",
        "wolverine",
        "piratas",
        "peterpan",
        "titanic",
        "lord",
        "karate",
        "silencio",
        "kill",
        "godfather",
        "resplandor",
        "mary",
        "mago",
        "blackpanther",
        "corazon",
        "inception",
        "harry",
        "simpsons",

        "aladino",
        "alicia",
        "alien",
        "ava",
        "baby",
        "batman",
        "bella",
        "ben",
        "big",
        "blancanieves",

        "buscando",
        "capitan",
        "car",
        "cenicienta",
        "coco",
        "dama",
        "dirty",
        "dracula",
        "emperor",
        "escuadron",

        "exorcista",
        "froz",
        "hombres",
        "home",
        "hunger",
        "ice",
        "increibles",
        "indiana",
        "iron",
        "it",

        "kung",
        "lilo",
        "mati",
        "matrix",
        "mega",
        "mision",
        "moa",
        "monsters",
        "mulan",
        "naufrago",

        "nosotros",
        "pesadilla",
        "picapiedra",
        "pino",
        "poca",
        "quien",
        "quinto",
        "rapsodia",
        "rata",
        "reyleon",

        "rock",
        "sabueso",
        "scooby",
        "shrek",
        "sirenita",
        "spiderman",
        "starwars",
        "super",
        "tarzan",
        "termi",

        "thor",
        "tiburon",
        "tomb",
        "top",
        "toy",
        "trans",
        "up",
        "vase",
        "villano",
        "volver",

        "wall",
        "wonder",
      ],
      dulceria: [
        "dulceria1",
        "dulceria2",
        "dulceria3",
        "dulceria4",
        "dulceria5",
        "dulceria6",
        "dulceria7",
        "dulceria8",
        "dulceria9",
        "dulceria10",
        "dulceria11",
      ],
      overlay_transaccion: false,
      overlay_sucursal: false,
      user: null,
      resultados_usuario: null,
      resultados_top_grupo: null,
      semana: 1,
    };
  },
  computed: {
    ...mapState(["userProfile", "posts"]),
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    this.user = localStorage.getItem("user_copaprosa2021");
    this.user = JSON.parse(this.user);
    this.traeResultados();
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    traeResultados() {
      const https = require("https");
      var qData = {
        no_cliente: this.user.no_cliente,
        semana: this.semana,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "resultados.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              //bien
              this.resultados_usuario = res.resultados_usuario[0];
              this.resultados_top_grupo = res.resultados_top_grupo;

              console.log(this.resultados_usuario);
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    createPost() {
      this.$store.dispatch("createPost", { content: this.post.content });
      this.post.content = "";
    },
    toggleCommentModal(post) {
      this.showCommentModal = !this.showCommentModal;

      // if opening modal set selectedPost, else clear
      if (this.showCommentModal) {
        this.selectedPost = post;
      } else {
        this.selectedPost = {};
      }
    },
    likePost(id, likesCount) {
      this.$store.dispatch("likePost", { id, likesCount });
    },
    async viewPost(post) {
      const docs = await commentsCollection
        .where("postId", "==", post.id)
        .get();

      docs.forEach((doc) => {
        let comment = doc.data();
        comment.id = doc.id;
        this.postComments.push(comment);
      });

      this.fullPost = post;
      this.showPostModal = true;
    },
    closePostModal() {
      this.postComments = [];
      this.showPostModal = false;
    },
    fileSelected: function ($event) {
      this.file = $event.target.files[0];

      var reader = new FileReader();

      reader.onload = function (e) {
        // get loaded data and render thumbnail.
        var preview = document.getElementById("preview");
        var image = document.createElement("img");
        image.src = e.target.result;
        preview.innerHTML = "";
        preview.appendChild(image);
        console.log(preview);

        swal.fire(
          "Bien",
          "Recuerda conservar tus tickets de compra, da click en continuar para participar.",
          "success"
        );
      };

      // read the image file as a data URL.
      reader.readAsDataURL(this.file);
    },
    async tomarTrivia() {
      if (this.file == null) {
        swal.fire(
          "Oops",
          "Sube la foto de un ticket antes de continuar...",
          "warning"
        );
        return;
      }

      if (this.no_sucursal == null) {
        swal.fire(
          "Oops",
          "Ingresa el número de sucursal de tu ticket de compra...",
          "warning"
        );
        return;
      }

      if (this.no_transaccion == null) {
        swal.fire(
          "Oops",
          "Ingresa el número de transacción de tu ticket de compra...",
          "warning"
        );
        return;
      }

      this.$store.dispatch("registroTicket", {
        monedero: this.monedero,
        file: this.file,
        no_sucursal: parseInt(this.no_sucursal),
        no_transaccion: parseFloat(this.no_transaccion),
      });
    },
    toggleSucursal() {
      this.overlay_sucursal = !this.overlay_sucursal;
    },
    toggleTransaccion() {
      this.overlay_transaccion = !this.overlay_transaccion;
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }

      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>

<style lang="scss" scoped>
.overlayticket {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100000;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  .bg-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
  }
  .ticket {
    width: 50%;
    margin: 0 25%;
    .head {
      width: 100%;
      .cerrar {
        text-align: right;
        cursor: pointer;
        user-select: none;
      }
    }
    .body {
    }
  }
}
</style>
